'use client';

import type { ReactNode } from 'react';
import { definitions } from '@micro-apps/env';
import ShoppingCartSummary from './shopping-cart-summary-component';
import { useMediaQuery } from 'react-responsive';
import { MobileExpandableContent } from './mobile-wrapper';
import { CheckoutContent } from '../../types';

const MainWrapper = ({
	children,
	amount,
	currencyCode,
	previewQuoteButton,
}: {
	children: React.ReactNode;
	amount?: number;
	currencyCode?: string;
	previewQuoteButton?: ReactNode;
}) => {
	const isLg = useMediaQuery({ minWidth: '960px' });
	return !isLg ? (
		<MobileExpandableContent amount={amount} currencyCode={currencyCode}>
			{children}
		</MobileExpandableContent>
	) : (
		<div className="flex flex-col w-[400px] spacing-stack-l">
			{previewQuoteButton}
			{children}
		</div>
	);
};

type MainComponentProps = {
	officialName: {
		__html: string;
	};
	booking?: definitions['booking'];
	checkoutContent?: CheckoutContent;
	basket?: definitions['eventProduct'][];
	estimatedTotalDisclaimer: string;
	removeBooking?: () => void;
	removeFromCart?: (productId: string) => void;
	showPriceBreakdown?: () => void;
	ppMode?: boolean;
	isMultiRoom?: boolean;
	previewQuoteButton?: ReactNode;
};

export default function MainComponent({
	officialName,
	booking,
	checkoutContent,
	basket,
	estimatedTotalDisclaimer,
	removeBooking,
	removeFromCart,
	showPriceBreakdown,
	ppMode,
	isMultiRoom,
	previewQuoteButton,
}: MainComponentProps) {
	return (
		<MainWrapper
			amount={booking?.price?.total?.cash?.amount}
			currencyCode={booking?.price?.total?.cash?.currencyCode}
			previewQuoteButton={previewQuoteButton}
		>
			<ShoppingCartSummary
				officialName={officialName}
				booking={booking}
				checkoutContent={checkoutContent}
				basket={basket}
				estimatedTotalDisclaimer={estimatedTotalDisclaimer}
				removeBooking={removeBooking}
				removeFromCart={removeFromCart}
				showPriceBreakdown={showPriceBreakdown}
				ppMode={ppMode}
				isMultiRoom={isMultiRoom}
			/>
		</MainWrapper>
	);
}
